export default __webpack_public_path__ + "static/media/heart-filled.48da6d70.svg";